import CloseIcon from "@mui/icons-material/Close";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../CustomButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const SubscriptionExpireAlert = forwardRef(
  ({ handleRenewSubscription }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        paramsData = params;
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="subscription-expired-dialog-title"
        open={open}
      >
        <IconButton
          sx={{ position: "absolute", top: "5px", right: "5px" }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          variant="h1"
          fontWeight={600}
          fontSize={"1.5rem"}
          fontFamily={"Inter"}
          sx={{ m: 0, p: 2 }}
          id="subscription-expired-dialog-title"
        >
          {t("subscriptionExpired")}
        </DialogTitle>
        <DialogContent dividers>
          <Stack alignItems={"center"} justifyContent={"center"}>
            <ReportGmailerrorredIcon
              htmlColor={"red"}
              sx={{
                fontSize: "5rem",
              }}
            />
          </Stack>
          <Typography variant={"body1"} mt={2.5} textAlign={"center"}>
            {paramsData?.warningText ||
              t('subscriptionExpiredMessage')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <GlobalButton
            variant={"custom_outlined"}
            btnText={"close"}
            handleClickBtn={handleClose}
            styleProps={{
              height: 38,
              width: 100,
              borderRadius: "6px",
            }}
          />
          <GlobalButton
            btnText={"renewSubscription"}
            handleClickBtn={() => handleRenewSubscription(paramsData)}
            styleProps={{
              height: 38,
              width: "auto",
              borderRadius: "6px",
            }}
          />
        </DialogActions>
      </BootstrapDialog>
    );
  }
);

export default SubscriptionExpireAlert;
